import React from 'react';
import { useFormik, FormikProvider } from 'formik';

import { Container, Button } from 'theme-ui';

import Form from 'components/core/Form';

import * as Yup from 'yup';
import Spacer from 'elements/Spacer';
import { useHistory, Link } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

const Login: React.FC = () => {
  const { login } = useAuth();
  const history = useHistory();
  const loginForm = useFormik({
    initialValues: {
      username: '',
      password: ''
    },
    validationSchema: Yup.object({
      username: Yup.string().required('Required'),
      password: Yup.string().required('Required')
    }),
    onSubmit: async (values, { setFieldError, setSubmitting }) => {
      const { username, password } = values;
      const { error, authUser } = await login(username, password);

      if (error?.code === 'UserNotConfirmedException') {
        return history.push('signup/confirm');
      }

      if (error) {
        setFieldError('password', error.message);
      }

      if (!error && authUser) {
        return history.push('/');
      }

      setSubmitting(false);
    }
  });

  return (
    <Container>
      <FormikProvider value={loginForm}>
        <Form>
          <Form.Error name="username" component="div" />
          <Form.Label>Username</Form.Label>
          <Form.Field
            type="text"
            name="username"
            placeholder="Username"
            autoComplete="username"
          />

          <Spacer size={4} />

          <Form.Label>Password</Form.Label>
          <Form.Error name="password" component="div" />
          <Form.Field
            type="password"
            name="password"
            placeholder="Password"
            autoComplete="current-password"
          />

          <Spacer size={4} />

          <Button
            type="submit"
            bg={loginForm.isSubmitting ? 'muted' : 'primary'}
          >
            Submit
          </Button>

          <Spacer size={4} />

          <Link to="/signup" style={{ width: '100%' }}>
            <Button variant="secondary" sx={{ width: '100%' }}>
              Signup
            </Button>
          </Link>
        </Form>
      </FormikProvider>
    </Container>
  );
};

export default Login;
